module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('nav', {
    staticClass: "navbar navbar-static-top"
  }, [_c('router-link', {
    staticClass: "logo-side2",
    attrs: {
      "to": {
        name: 'ServiceMonitoring'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "\\static\\img\\icons\\logo-navbar.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [(_vm.window.width > 400) ? _c('label', {
    staticClass: "fechaNav",
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDate")(new Date(), 'dddd DD')))]) : _vm._e(), _vm._v(" "), (_vm.window.width > 400) ? _c('label', {
    staticClass: "fechaNav",
    staticStyle: {
      "padding-left": "5px",
      "padding-right": "5px"
    }
  }, [_vm._v("de")]) : _vm._e(), _vm._v(" "), (_vm.window.width > 400) ? _c('label', {
    staticClass: "fechaNav",
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDate")(new Date(), 'MMM YYYY')))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown user user-menu dropdown-per"
  }, [_c('a', {
    staticClass: "dropdown-toggle nav-user-info",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": "/static/img/icons/icon-user-default.png",
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs user-info"
  }, [_vm._v(_vm._s(_vm.userInfo.name.toLowerCase().trim()) + " ")]), _c('img', {
    attrs: {
      "src": "/static/img/arrow-logo.png"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-per",
    attrs: {
      "aria-labelledby": "dropdownMenuLink",
      "aria-expanded": "false",
      "id": "dropdownMenuButton"
    }
  }, [_c('li', [_c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn rectangle",
    attrs: {
      "to": {
        name: 'Logout'
      }
    }
  }, [_c('i', {
    staticClass: "exit-icon"
  }), _c('p', {
    staticClass: "user-close"
  }, [_vm._v("Cerrar Sesión")])])], 1)])])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c4e6c58!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/NaviBar.vue
// module id = 524
// module chunks = 1